import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Transition, Menu } from "@headlessui/react";
import AuthContext from "../context/AuthContext";
import { Link, useLocation } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { TbLogout2, TbPasswordUser } from "react-icons/tb";
import { LiaUserEditSolid } from "react-icons/lia";
import { IoNotifications } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import apiPath from "utils/apiPath";
import { apiDelete, apiGet } from "utils/apiFetch";
import helpers from "utils/helpers";
import Swal from "sweetalert2";
import { listenEvent } from "utils/initializeSocket";
import { MdDelete } from "react-icons/md";
import useToastContext from "hooks/useToastContext";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";

const TopNavBar = () => {
  const { logoutUser, user, handleSidebar, pageName, updatePageName, sidebarStatus, socket, notificationData, setNotificationData } = useContext(AuthContext);
  const location = useLocation()
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const notification = useToastContext()

  const handleLogout = () => {
    Swal.fire({
      html: `<b>${t("LOGOUT_MESSAGE")}</b>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        logoutUser();
      }
    });

  };

  const toggleNotifications = () => {
    setOpen(!open);
    setNotificationData()
  };


  const ref = useRef();

  // Click outside to close
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.1,
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 },
  };



  const [notificationList, setNotification] = useState([])

  const getNotifications = async () => {
    try {
      const payload = {
        limit: 5,
      }
      const result = await apiGet(apiPath.getProviderNotification, payload)
      if (result?.data?.success) {
        const response = result?.data?.results
        setNotification(response?.docs)
        return
      }
      setNotification([])
    } catch (error) {
      console.error('error ', error)
    }
  }

  const listenNotification = () => {
    listenEvent(socket, 'hasNewNotification', (data) => {
      if (data?.success) {
        setNotificationData(data)
      }

    });
  }

  useEffect(() => {
    if (open) {
      getNotifications()
      listenNotification()
    }
  }, [open])


  useEffect(() => {
    if (socket) {
      listenNotification()
    }
  }, [socket])



  const handleDelete = async (data) => {
    try {

      const result = await apiDelete(helpers.ternaryCondition(!isEmpty(data), apiPath.deleteNotification + '/' + data?._id, apiPath.deleteNotification))
      if (result?.data?.success) {
        notification.success(result?.data?.message)
        return
      }
      notification.error(result?.data?.message)
    } catch (error) {
      console.error('error ', error)
    }

  };


  return (
    <div className="linHeader border-b py-4 px-4 md:px-8 dark:bg-slate-900">
      <header className="bg-white items-center flex dark:bg-slate-900">
        <div className={`mr-4 dark:text-white z-50 cursor-pointer ${sidebarStatus === "open" ? "showToggleMenu" : ""}`} onClick={() => handleSidebar()}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
          </svg>
        </div>

        <div className="page_heading ">
          <h1 className="flex items-center text-lg text-slate-900 font-medium dark:text-white">{pageName}</h1>
        </div>

        <Menu as="div" className="flex items-center relative inline-block text-left hover:text-gradientTo sidebar_dropdown ml-auto">

          <Link to='/view-profile' > <span className={`text-sm mx-6 font-[500] dark:text-white ${helpers.ternaryCondition(location?.pathname == '/view-profile', 'border-b-2 px-[3px] border-gray-700', '')}`}>Profile</span></Link>
          <Link to='/help-and-support' ><span className={`text-sm mx-6 font-[500] dark:text-white ${helpers.ternaryCondition(location?.pathname == '/help-and-support', 'border-b-2 px-[3px] border-gray-700', '')}`}>Help</span></Link>

          <div ref={ref} >
            <div className="flex items-center mx-6 relative">
              <button onClick={toggleNotifications} className="relative mr-3">
                <IoNotifications className="text-right dark:text-white" size={25} />
                {helpers.andOperator(notificationData?.count, <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[9px] w-[18px] h-[18px] flex items-center justify-center rounded-full">
                  <span className="mt-[3px]">{helpers.ternaryCondition(notificationData?.count > 9, '9+', notificationData?.count)}</span>
                </span>)}
              </button>
            </div>
            <AnimatePresence>
              {open && (
                <motion.div
                  variants={containerVariants}
                  initial="hidden"
                  animate="visible"

                  className="absolute right-1 mt-2 w-[290px]  sm:min-w-[400px] bg-white border rounded-xl shadow-xl z-50 "

                >
                  <div className="p-4 border-b font-semibold text-gray-700 flex justify-between items-center">
                    Notifications
                    {helpers.andOperator(notificationList?.length>0,<button
                      className="bg-red-100 rounded-full px-2 py-1 text-[9px]"
                      title="Clear All"
                      onClick={() => helpers.alertFunction(`Are you sure you want to delete all notification?`, null, handleDelete)}
                    >
                      Clear All
                    </button>)}
                  </div>


                  <div className="max-h-96 overflow-y-auto">
                    {notificationList?.map((n) => (

                      <motion.div
                        key={n._id}
                        className="p-4 hover:bg-gray-50 transition-colors border-b"
                        variants={itemVariants}
                      >
                        <div className="flex items-start justify-between">
                          <div className="flex items-center gap-2">
                            <span className="h-2 w-2 mt-1 mb-1 rounded-full bg-blue-500"></span>
                            <h4 className="font-semibold text-sm">{n?.title}</h4>
                          </div>
                          <div className="flex items-center gap-2">
                            <p className="text-gray-400 text-xs whitespace-nowrap">
                              {helpers.getDateAndTime(n?.createdAt)}
                            </p>

                            <button
                              className="bg-red-100 rounded-full p-1 hover:bg-red-200"
                              title="delete"
                              onClick={() => helpers.alertFunction(`Are you sure you want to delete notification?`, n, handleDelete)}
                            >
                              <MdDelete size={16} className="text-red-600" />
                            </button>

                          </div>
                        </div>
                        <p className="text-sm text-gray-600 mt-1">{n?.description}</p>
                      </motion.div>

                    ))}
                    {helpers.andOperator(notificationList?.length == 0, <motion.div
                      className="p-4 transition-colors text-center text-sm"
                      variants={itemVariants}>
                      No notification found.

                    </motion.div>)}

                  </div>
                  {helpers.andOperator(notificationList?.length > 0, <div className="text-center p-3 text-blue-600 hover:underline cursor-pointer text-sm">
                    <Link to='/notification-manager'  onClick={()=>{setOpen(false)}}>
                      View All Notifications
                    </Link>
                  </div>)}
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div>
            <Menu.Button className="flex relative items-center w-full text-white active:text-gradientTo z-50">
              <span title={t("O_NOTIFICATION")}></span>
              <div className="profile flex items-center ml-auto md:mr-10 mr-2">
                {/* <figure className="inline-block overflow-hidden rounded-full">
                  <OImage src={user?.profilePic} fallbackUrl="/images/user.png" className="w-[40px] h-[40px] inline" alt="" />
                </figure> */}
                <small className="block text-sm text-slate-900 ml-2 md:block hidden dark:text-white">{user?.firstName + " " + user?.lastName}</small>
              </div>
            </Menu.Button>
          </div>


          <Transition
            as={Fragment}
            enter="transition ease-out duration-10"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute z-10 text-left min-w-[200px]  right-2 content divide-y divide-gray-100  bg-white shadow-lg ring-1 top-10 ring-black ring-opacity-5 focus:outline-none">
              <div className="">
                <Menu.Item onClick={() => updatePageName("Edit profile")}>
                  {({ active }) => (
                    <Link to="/view-profile" className={`${active ? "bg-gradientTo text-white" : "text-gray-900"} group flex w-full items-center  px-4 py-2 text-sm gap-2`}>
                      <LiaUserEditSolid size={20} />
                      View profile
                    </Link>
                  )}
                </Menu.Item>
                <Menu.Item onClick={() => updatePageName("Change password")}>
                  {({ active }) => (
                    <Link to="/change-password" className={`${active ? "bg-gradientTo text-white" : "text-gray-900"} group flex w-full items-center  px-4 py-2 text-sm gap-2`}>
                      <TbPasswordUser size={20} />
                      Change password
                    </Link>
                  )}
                </Menu.Item>
              </div>
              <div className="">
                <Menu.Item>
                  {({ active }) => (
                    <button onClick={handleLogout} className={`${active ? "bg-gradientTo text-white" : "text-gray-900"} group flex w-full items-center  px-4 py-2 text-sm gap-2`}>
                      <TbLogout2 size={20} />
                      Logout
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
        <span className="relative right-[20px]">
          <IoIosArrowDown />
        </span>
      </header>

    </div>

  );
};

export default TopNavBar;
